const DEFAULT_PLACEHOLDERS: Record<string, string> = {
  user: 'User',
  name: 'Name',
  email: 'user@example.com',
  EMAIL: 'user@example.com',
};

export const replaceEmailTemplateVariables = (text: string | undefined): string => {
  if (!text) {
    return '';
  }

  return text.replace(/\{\{([a-zA-Z_][a-zA-Z0-9_]*)\}\}/g, (_, key: string) => {
    const normalizedKey = key.toLowerCase();
    const placeholder = DEFAULT_PLACEHOLDERS[key] ?? DEFAULT_PLACEHOLDERS[normalizedKey];

    return placeholder ?? `{{${key}}}`;
  });
};
